import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
  Backdrop,
  CircularProgress,
  styled,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";

const CardBlock = ({ open, onClose, bocardId, uniqueId, cardStatus }) => {

  const [description, setDescription] = useState("");
  const [bocardIdState, setBocardIdState] = useState("");
  const [uniqueIdState, setUniqueIdState] = useState("");
  const [suspended, setSuspended] = useState(false);
  const [loading, setLoading] = useState(false);

  // Reset and initialize data when the dialog is opened
  useEffect(() => {
    if (open) {
      setLoading(false);
      setDescription("");
      setBocardIdState(bocardId || ""); // Initialize with passed bocardId
      setUniqueIdState(uniqueId || ""); // Initialize with passed uniqueId
      setSuspended(cardStatus === "ACTIVE" ? false : true); // Set suspended based on cardStatus
    }
  }, [open, bocardId, uniqueId, cardStatus]);

  // Handle close dialog
  const handleClose = () => {
    setLoading(false);
    setDescription("");
    setBocardIdState("");
    setUniqueIdState("");
    setSuspended(false);
    onClose();
  };

  // Handle submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

        // descrption is required
        if (!description) {
            toast.error("Description is required.");
            setLoading(false);
            return;
        }
      const response = await axios.post(
        `/api/api/card/suspendUnsuspendCard`,
        {
            bocardId: bocardIdState,
            uniqueId: uniqueIdState,
            description: description,
            isSuspend: cardStatus === "ACTIVE" ? true : false,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast.success("Card Freeze/Unfreeze created successfully!");

      setSuspended(cardStatus === "ACTIVE" ? true : false); // Update suspended state based on cardStatus
      handleClose();
            // reload the page
            window.location.reload();
    } catch (error) {
      console.error(error);
      toast.error("Failed to create Card Freeze/Unfreeze.");
    } finally {
      setLoading(false);
    }
  };

  // Handle suspended change
  const handleSuspendedChange = (event) => {
    setSuspended(event.target.value === "true");
  };

  // Custom styles for the Backdrop and CircularProgress components
  const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  }));

  const CustomCircularProgress = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.primary.main,
  }));

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Card {suspended ? "Unfreeze" : "Freeze"} </DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              label={`Reason for ${suspended ? "Unfreeze" : "Freeze"}`}
              variant="outlined"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              value={description}
              required
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={loading} onClick={handleSubmit}>
            {suspended ? "Unfreeze" : "Freeze"}
          </Button>
        </DialogActions>

        {/* Loading spinner */}
        {loading && (
          <CustomBackdrop open={loading}>
            <CustomCircularProgress />
          </CustomBackdrop>
        )}
      </Dialog>
    </>
  );
};

export default CardBlock;
